import { DeviceInfo } from "../../../Device/Info/DeviceInfo";
import { Event } from "../../../Global/Base/Events";
import { AlignPanelWidthCounter, helper } from "./AlignPanelWidthCounter";
/** Pomocna trida pro nastavovani resize listeneru na detail framy.  */
export class FormSizeComparer {
    public static listeners: any[] = [];

    /**
     * Nastavi resize listenery na minimalni potrebnou vysku a sirku pro kazdy DetailFrame.
     * Pro Pages bere nejvetsi sirku/vysku ze vsech zalozek.
     */
    public static setResizeListeners(element: HTMLElement, _compareImmediately: boolean, _resizedEvent: Event<any, any>, _horizontalLayout: boolean = true): void {
        let containers: HTMLElement[] = [];
        if (element) {
            containers = helper.toArray<HTMLElement>(element.querySelectorAll("[data-tsccontrol=\"DetailFrame\"]"));
        }

        if (!containers.length) { // kdyz form neobsahuje Detail, vezme se prvni align panel
            containers = [AlignPanelWidthCounter.getFirstAlignPanel(element)]; //tu
        }

        if (containers[0] !== null && containers.length > 0) {
            containers.forEach((container) => { // muze byt vic Detailu ve formu
                const containerAlignPanel: HTMLElement = AlignPanelWidthCounter.getFirstAlignPanel(container);
                if (!containerAlignPanel) {
                    return;
                }

                containerAlignPanel.classList.add("counted");

                if (DeviceInfo.deviceProperties.phone) { // telefon bude mit vzdy sloupcove zobrazeni detailu
                    return;
                }

                containerAlignPanel.classList.add("fits");
            });
        }
    }
}
